<section class="bread-crumbs border-bottom-1">
 
  <div class="d-flex justify-content-start align-items-center col-md-12 flex-wrap container">
    <a class="d-flex main-breadcrump-menu" [routerLink]="'/' + lang">
      <span class="material-icons mx-1">home</span>
      <span class="d-flex align-items-center" [ngClass]="{ 'arabic-font': lang === 'ar' }">
        {{ "header.home" | translate }}
      </span>
    </a>
    <span class="material-icons">
      {{ lang === "en" ? "chevron_right" : "chevron_left" }}
    </span>
    <ng-container *ngFor="let item of routes; let i = index; let last = last">
      <span *ngIf="i > 0" class="material-icons">
        {{ lang === "en" ? "chevron_right" : "chevron_left" }}
      </span>
      <a class="m-1 pointer text-capitalize title font-weight-bold name"
        *ngIf="!last"
        [routerLink]="generateRouterLink(item, i)"
      >
        {{ lang === "en" ? item?.name_en : item?.name_ar }}
      </a>
      <span class="mx-1 product-name" 
        [ngClass]="{'d-md-block d-none' : environmentVariables?.NEW_PRODUCTS_DETAILS_UI}"
        *ngIf="last">
        {{ lang === "en" ? item?.name_en : item?.name_ar }}
      </span>
    </ng-container>
  </div>
</section>
